import { mapGetters } from 'vuex';

export default {
    name: 'propertyMls',
    inject: ['$eventBus'],

    props: {
        buyingOffice: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            isMounted: false,
            complainceInfo: null,
            brokerInfo: null,
            rentalInfo: {},
        };
    },
    computed: {
        ...mapGetters('glb', ['glb', 'getPhoneNumber', 'getSplit', 'removeAds']),
        ...mapGetters('dpp', ['dpp', 'getMlsInfo', 'getUpdatedStatus', 'isActive']),
        nhsExternalLink() {
            var link = 'https://www.newhomesource.com/?refer=Movoto';
            if (this.dpp.features && this.dpp.features.length && this.dpp.isNHS) {
                var planInformation = this.dpp.features.filter((feature) => feature.name === 'Plan Information');
                if (planInformation && planInformation.length) {
                    link = planInformation[0].value
                        .filter((pI) => {
                            return pI.name === 'Plan Details';
                        })[0]
                        .value.filter((pD) => {
                            return pD.name === 'Home Details Website';
                        })[0].value;
                }
            }
            return link;
        },
        rdcExternalLink() {
            const citySlug = this.dpp.geo.city.trim().replace(/\s+/g, '-');
            return `https://www.realtor.com/newconstructionhomes/${citySlug}_${this.dpp.geo.state}`;
        },
        listingAgent() {
            let prefix = '';
            if (this.dpp.listingAgent) {
                if (this.getMlsInfo.id == 484) {
                    prefix = 'Listing Courtesy of ';
                }
                return prefix + this.dpp.listingAgent;
            }
        },
        mlsLogoSrc() {
            if (this.getMlsInfo.id) {
                return `${this.glb.cdnUrl}images/desktop/logo/logo_${this.getMlsInfo.id}.png`;
            }
        },
        lastChecked() {
            if (
                this.getUpdatedStatus.lastChecked &&
                this.getUpdatedStatus.lastChecked != this.getUpdatedStatus.lastUpdate &&
                ~['ACTIVE', 'PENDING', 'SOLD', 'FOR_RENT'].indexOf(this.dpp.houseRealStatus)
            ) {
                return this.getUpdatedStatus.lastChecked;
            }
        },
    },
    methods: {
        ...mapGetters('glb', ['getComplianceMethod']),
        complianceHidePhone() {
            const compliance = this.getComplianceMethod()();
            var rules = compliance[0] && compliance[0].rule;
            if (!rules || !rules.length) {
                return false;
            }
            if (~rules.indexOf('hidePhoneIcon')) {
                return true;
            }
        },
        showMLSCheckTimestamp(timestamp) {
            if (!timestamp) {
                return false;
            }
            const compliance = this.getComplianceMethod()();
            var rules = compliance[0] && compliance[0].rule;
            if (!rules || !rules.length) {
                return false;
            }
            if (~rules.indexOf('showMLSCheckTimestamp')) {
                return true;
            }
        },
        basicInfoDisclaimer() {
            const compliance = this.getComplianceMethod()();
            if (compliance[0] && compliance[0].rule.indexOf('disclaimerUnderBasicInfo') >= 0) {
                let office = this.dpp.complianceListOffice || '';
                return compliance[0].desc1.replace(/\[ListingOfficeName\]/gi, office);
            }
        },
        brokerInfoDetails() {
            let details = [];
            if (this.brokerInfo) {
                this.brokerInfo.dppBrokerName && details.push(this.brokerInfo.dppBrokerName);
                this.brokerInfo.dppBrokerLicense && details.push(`License #${this.brokerInfo.dppBrokerLicense},`);
                this.brokerInfo.dppBrokerOffice && details.push(this.brokerInfo.dppBrokerOffice);
                this.brokerInfo.dppBrokerAddress && details.push(this.brokerInfo.dppBrokerAddress);
            }
            return details.join(' ');
        },
        sendGA() {
            this.$eventBus.$emit('ga', { ec: 'partner', en: 'NHS_link_clicked', el: 'NHS', props: { link_name: 'Newhomesource.com' } });
        },
        initComplainceInfo() {
            this.isMounted = true;
            const compliance = this.getComplianceMethod()();
            this.complainceInfo = compliance[0] || {};
            this.rentalInfo = (this.complainceInfo && this.complainceInfo.rentals) || {};
            this.brokerInfo = this.complainceInfo && this.complainceInfo.broker;
        },
        getRentalUrl() {
            const url = this.glb.rentalLink || this.rentalInfo.source;
            return url ? `${url}${this.rentalInfo.urlrefer}` : '';
        },
    },
    mounted() {
        this.initComplainceInfo();
    },
};
